import type { CredentialCard } from '@/types';
import { Hack25CredentialCard } from './Hack25CredentialCard';
import { Hack26CredentialCard } from './Hack26CredentialCard';

// Which of the two card designs an edition prints, and the strings printed on it. All of
// it comes from config/credentials/<edition>.yml through the page's props.
export interface CardDesign {
  card: string;
  dateLabel: string | null;
  cityLabel: string | null;
  sponsorsAsset: string | null;
  cardFootMarginTop: number | null;
}

export function CredentialCardView({
  card,
  design,
  rounded = true,
}: {
  card: CredentialCard;
  design: CardDesign;
  rounded?: boolean;
}) {
  if (design.card === 'hack-25') {
    return <Hack25CredentialCard card={card} />;
  }

  return (
    <Hack26CredentialCard
      card={card}
      dateLabel={design.dateLabel ?? ''}
      cityLabel={design.cityLabel ?? ''}
      sponsorsAsset={design.sponsorsAsset ?? ''}
      footMarginTop={design.cardFootMarginTop}
      rounded={rounded}
    />
  );
}
